<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Change`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.8672 19.2692C18.7339 19.3952 18.5971 19.5176 18.457 19.6362L18.4146 19.6745C18.3837 19.7023 18.3517 19.7278 18.3188 19.7511C16.5964 21.1569 14.3966 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2712 2 18.1755 3.57069 20 5.99902V4C20 3.44772 20.4477 3 21 3C21.5523 3 22 3.44772 22 4V8.5C22 9.05229 21.5523 9.5 21 9.5H16.5C15.9477 9.5 15.5 9.05229 15.5 8.5C15.5 7.94772 15.9477 7.5 16.5 7.5H18.6153C17.1753 5.38723 14.7497 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.9111 20 15.6658 19.3299 17.0417 18.2117C17.052 18.2016 17.0626 18.1917 17.0735 18.182L17.6996 17.6219C18.0992 17.2644 18.7095 17.2851 19.0839 17.6688C19.4809 18.0755 19.4602 18.7307 19.0383 19.1115L18.865 19.2679L18.8672 19.2692Z"/></svg>
</template>
<script>

export default {
  name: 'IconChange',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
